import React from 'react';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { formatFileSize } from '../utils';

const AttachmentItem = ({ item }) => {
  if (item.kind === 'image') {
    return (
      <a href={item.url} target="_blank" rel="noreferrer">
        <img src={item.url} alt={item.name || 'вложение'} className="max-h-64 max-w-[280px] rounded-lg object-contain" />
      </a>
    );
  }

  if (item.kind === 'video') {
    return <video src={item.url} controls className="max-h-64 max-w-[280px] rounded-lg" />;
  }

  return (
    <a href={item.url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 break-all text-sm underline">
      <AttachFileIcon fontSize="small" />
      <span>{item.name || 'файл'}</span>
      {item.size ? <span className="text-xs opacity-70">{formatFileSize(item.size)}</span> : null}
    </a>
  );
};

const Attachments = ({ attachments = [] }) => {
  if (!attachments.length) return null;

  return (
    <div className="mt-2 flex flex-col gap-2">
      {attachments.map((item, index) => (
        <AttachmentItem key={`${item.name || 'file'}-${item.size || index}-${index}`} item={item} />
      ))}
    </div>
  );
};

export default Attachments;
